module.exports = __webpack_public_path__ + "img/miniMedal.60193ec5.png";